<template>
  <div class="container-fluid">
    <share-modal v-if="isBrowser" ref="shareModal"></share-modal>

    <header-box></header-box>
    <div class="main">
      <div class="container">
        <div id="news" class="banner">
          <div class="row">
            <div class="banner-col-7 col-xs-12 col-sm-7">
              <img
                class="hidden-xs"
                src="../../assets/images/media_banner.png"
                alt
              />
              <img
                class="visible-xs"
                src="../../assets/images/media_banner_mobile.png"
                alt
              />
              <div class="info">
                <div class="title">媒体报道</div>
                <div class="subtitle">{{ newList[1].title }}</div>
                <div class="txt-content">{{ newList[1].content }}</div>
                <button class="btn" @click="jump(newList[1].url)">
                  更多详情
                </button>
              </div>
            </div>
            <div class="banner-col-5 col-xs-12 col-sm-5">
              <div class="header">
                <h2>新闻动态</h2>
                <div class="pageButtonList">
                  <button
                    class="btn"
                    @click="handleClick('leftBtn')"
                    :disabled="curPage === 1"
                    :class="curPage === 1 ? 'btn-disabled' : ''"
                  >
                    <!-- <b-icon icon="chevron-left"></b-icon> -->
                    <span class="icon iconfont iconzu2"></span>
                    <!-- < -->
                  </button>
                  <button
                    class="btn"
                    @click="handleClick('rightBtn')"
                    :disabled="curPage === totalPage"
                    :class="curPage === totalPage ? 'btn-disabled' : ''"
                  >
                    <span class="icon iconfont iconzu3"></span>
                  </button>
                </div>
              </div>
              <div
                class="list-container"
                v-for="(item, index) in getCurPageContent(
                  newList,
                  curPage,
                  perPage
                )"
                :key="index"
                @click="jump(item.url)"
              >
                <div class="content">
                  <h3 class="title">{{ item.title }}</h3>
                  <div class="subtitle">{{ item.content }}</div>
                  <div class="time">
                    <span class="icon iconfont iconIcon-time1"></span>
                    {{ item.time }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="video-arr" id="video-box">
          <div class="row">
            <div class="col-xs-12">
              <h1>
                <p>视频报道</p>
                <span class="hidden-xs" @click="nextVideoPage">下一页</span>
              </h1>
            </div>
          </div>
          <div class="his-list">
            <div
              class="list-container"
              v-for="(item, index) in getCurPageContent(
                videoArr,
                videoCurPage,
                videoPerPage
              )"
              :key="index"
              @click="jump(item.url)"
            >
              <div class="card panel panel-default hidden-xs">
                <div class="panel-heading card-title half-bottom-border">
                  <template>
                    <img
                      v-if="item.thumb_url"
                      :src="item.thumb_url"
                      class="img-responsive video-pic"
                    />
                    <img
                      v-else
                      class="img-responsive video-pic"
                      src="../../assets/images/cache.png"
                      alt=""
                    />
                  </template>

                  <div class="video_btn">
                    <img src="../../assets/images/video-start.png" alt />
                  </div>
                </div>
                <div class="penel-body card-body">
                  <h3 class="title">{{ item.title }}</h3>
                  <div class="card-txt">
                    <p class="txt">{{ item.digest }}</p>
                    <p class="time">
                      <span class="icon iconfont iconIcon-time1"></span>
                      {{ item.create_time.split(" ")[0] }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="visible-xs">
                <div class="card">
                  <div class="card-left">
                    <img :src="item.thumb_url" class="img-responsive" />
                    <div class="video_btn">
                      <img src="../../assets/images/video-start.png" alt />
                    </div>
                  </div>
                  <div class="card-body">
                    <h4 class="card-heading">{{ item.title }}</h4>
                    <p class="txt">{{ item.digest }}</p>
                    <p class="time">
                      <span class="icon iconfont iconIcon-time1"></span>
                      {{ item.create_time.split(" ")[0] }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="history" class="history">
          <div class="row">
            <div class="col-xs-12">
              <h1>历史报道</h1>
            </div>
          </div>
          <div class="his-list">
            <div
              class="list-container"
              v-for="(item, index) in getCurPageContent(
                imageArr,
                hisCurPage,
                hisPerPage
              )"
              :key="index"
              @click="jump(item.url)"
            >
              <div class="card panel panel-default hidden-xs">
                <div class="panel-heading card-title half-bottom-border">
                  <img :src="item.thumb_url" alt class="img-responsive" />
                </div>
                <div class="penel-body card-body">
                  <h3 class="title">{{ item.title }}</h3>
                  <div class="card-txt">
                    <p class="txt">{{ item.digest }}</p>
                    <p class="time">
                      <span class="icon iconfont iconIcon-time1"></span>
                      {{ item.create_time.split(" ")[0] }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="visible-xs">
                <div class="card">
                  <div class="card-left">
                    <img :src="item.thumb_url" alt />
                  </div>
                  <div class="card-body">
                    <h4 class="card-heading">{{ item.title }}</h4>
                    <p class="txt">{{ item.digest }}</p>
                    <p class="time">
                      <span class="icon iconfont iconIcon-time1"></span>
                      {{ item.create_time.split(" ")[0] }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <el-pagination
            class="his-pagination hidden-xs"
            background
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            :page-count="hisPageCount"
            :page-size="hisPerPage"
            :total="imageArr.length"
            @current-change="pageChange"
          ></el-pagination>
          <el-select
            class="visible-xs mobile-pagination"
            v-model="mobileCurrentPage"
            placeholder="请选择"
            size="mini"
            @change="mobilePageChange"
          >
            <el-option
              v-for="item in maxLength"
              :key="item"
              :label="item"
              :value="item"
            >
              <span>{{ item }}</span>
              <span>/</span>
              <span>{{ maxLength }}</span>
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <footer-box></footer-box>
  </div>
</template>

<script>
import HeaderBox from "components/header/header";
import FooterBox from "components/footer/footer";
import ShareModal from "components/sharemodal/sharemodal";

export default {
  components: {
    HeaderBox,
    FooterBox,
    ShareModal
  },
  data() {
    return {
      newList: [
        {
          title: "数字化浪潮新十年，微电子站牌助力城市智慧出行",
          content:
            "微电子站牌，便民新型数字站牌，区别于传统站牌的互联网产品，为市民提供了多元化的公交出行查询方式，大幅提升出行效率。",
          time: "2023-05-11",
          url:
            "https://mp.weixin.qq.com/s?__biz=MjM5MTE0MTE2Mw==&mid=2650697303&idx=1&sn=f88ba8fd8df66dca59ee832bd0bd0e71&chksm=beb0d21389c75b0599040146c12fef891ff82463598a6f2d38056897d4c6c9de308ef7d025bd#rd"
        },

        {
          title: "网约微公交，解决公共出行“最后一公里”难题",
          content:
            "为了针对性解决市民“最后一公里”的难题，一些与“掌上公交”合作城市的公共交通部门和公交公司经过反复研究，打造了微型巴士服务解决方案，连接大型居民社区、工业/商业园区、旅游景点等多种场景的短途快速接驳型公交线路。",
          time: "2023-05-11",
          url:
            "http://mp.weixin.qq.com/s?__biz=MjM5MTE0MTE2Mw==&mid=2650697345&idx=1&sn=498b58927a19be1b7b3b668167753b3b&chksm=beb0d2c589c75bd3f034c98d2f0ca7f9edbd6a1c7ca931cbb3910e9e14963a20e8bf4a3482f3#rd"
        },
        {
          title: "装了这个APP，我再也没等过公交",
          content:
            "为提供信息化民生服务，助力“公交都市”和“智慧城市”建设，福州市交通局落实“互联网+公交”重要举措，全面推广以“掌上公交” APP为载体的智能交通服务系统，加速新一代信息基础设施建设，实现了全市400多条公交线路、7000多个站点的实时公交信息查询和预报服务。",
          time: "2020-03-17",
          url: "https://mp.weixin.qq.com/s/hY8AnTE9v-zSQtllBBdbvg"
        },
        {
          title:
            "喜报 | 掌上公交参建“厦门城市公交综合智慧系统”获批国家交通运输部科技示范工程",
          content:
            "近日，国家交通运输部公布了2020年启动实施的交通运输部科技示范工程名单，掌上公交（厦门搜谷信息科技有限公司）作为主要参建单位的“厦门城市公交综合智慧系统”成功获批交通运输部科技示范工程。该工程是福建省首个交通运输部科技示范工程，对于省交通运输厅统筹行业科技资源、推进科技成果推广应用和开放共享，建立以企业为主体、产学研用深度融合的科技创新体系具有重要意义。",
          time: "2020-03-07",
          url: "https://mp.weixin.qq.com/s/Y5bFq6Aistqp_fDEqcP2tg"
        }
      ],
      perPage: 2,
      curPage: 1,
      totalPage: 2,
      imageArr: [],
      videoArr: [],
      mobileCurrentPage: "",
      maxLength: "",
      maxVideoLength: "",
      hisCurPage: 1,
      hisPerPage: 9,
      hisPageCount: 9,
      videoCurPage: 1,
      videoPerPage: 6,
      curConfig: {},
      showOverlay: true,
      isBrowser: false
    };
  },
  computed: {
    rows() {
      return this.items.length;
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 1);
      window.scrollTo(0, 0);
    });
    this.init();
    this.curConfig = this.$browser();
    if (this.curConfig.isPC) {
      this.hisPerPage = 6;
      this.videoPerPage = 3;
    }
    this.load();
  },
  methods: {
    init() {
      this.totalPage = Math.ceil(this.newList.length / this.perPage);
      this.totalPage = this.totalPage < 1 ? 1 : this.totalPage;
    },
    getCurPageContent(items, curPage, perPage) {
      console.log(items, "item", curPage, perPage);
      return items.filter(function(element, index) {
        if (index >= (curPage - 1) * perPage && index < curPage * perPage) {
          return true;
        } else {
          return false;
        }
      });
    },
    handleClick: function(arg) {
      if (arg == "leftBtn") {
        this.curPage = this.curPage > 1 ? --this.curPage : this.totalPage;
      } else if (arg == "rightBtn") {
        this.curPage = this.curPage < this.totalPage ? ++this.curPage : 1;
      }
    },
    // 历史报道
    pageChange(page) {
      // console.log(page);
      this.hisCurPage = page;
    },
    mobilePageChange(value) {
      this.hisCurPage = value;
      this.mobileCurrentPage = `${value}/${this.maxLength}`;
    },
    nextVideoPage() {
      this.videoCurPage++;
      if (this.videoCurPage > this.maxVideoLength) this.videoCurPage = 1;
    },
    showPicOverlay(i) {
      this.imageArr[i].showOverlay = true;
    },
    hidePicOverlay(i) {
      this.imageArr[i].showOverlay = false;
    },
    async load() {
      // console.log(this.$http);
      let param = {};
      const res = await this.$http.get(`GetMaterial`, param);

      let items = res.data;
      let imageArr = [];
      let videoArr = [];
      for (let i = 0; i < items.length; i++) {
        if (items[i].news_type == "video" && items[i].url) {
          videoArr.push(items[i]);
        } else {
          imageArr.push(items[i]);
        }
      }
      items.forEach(item => {
        item.showOverlay = false;
      });
      this.maxLength = Math.ceil(imageArr.length / this.hisPageCount);
      this.maxVideoLength = Math.ceil(videoArr.length / 3);
      this.mobileCurrentPage = `1/${this.maxLength}`;
      this.imageArr = imageArr;
      this.videoArr = videoArr;
      // console.log(videoArr, this.maxLength, this.maxVideoLength);
    },
    jump(url) {
      window.open(url);
    },
    getPic() {
      return require("../../assets/images/WechatIMG216.jpeg");
    }
  }
};
</script>
<style lang="less" scoped>
@import "./media.less";
</style>
<style lang="less">
@media (max-width: 539px) {
  .mobile-pagination {
    width: 40%;
    margin: 16px auto;
    .el-input {
      input {
        border-radius: 0;
        // border-color: #ff6000;
        text-align: center;
        &:focus {
          border-color: #ff6000 !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/media/media.vue